import { GET, POST, PUT, DELETE } from "../../../api";

export const findAll = async (
  currentPage,
  perPage,
  search,
  searchDateFrom,
  searchDateTo
) => {
  return await GET(
    `/admin/wallet?page=${currentPage || 1}&per_page=${perPage || 10}&name=${
      search || ""
    }&from=${searchDateFrom || ""}&to=${searchDateTo || ""}`
  );
};
export const findAllAccept = async (
  currentPage,
  perPage,
  search,
  searchDateFrom,
  searchDateTo
) => {
  return await GET(
    `/admin/wallet/accept?page=${currentPage || 1}&per_page=${
      perPage || 10
    }&name=${search || ""}&from=${searchDateFrom || ""}&to=${
      searchDateTo || ""
    }`
  );
};
export const findAllReject = async (
  currentPage,
  perPage,
  search,
  searchDateFrom,
  searchDateTo
) => {
  return await GET(
    `/admin/wallet/reject?page=${currentPage || 1}&per_page=${
      perPage || 10
    }&name=${search || ""}&from=${searchDateFrom || ""}&to=${
      searchDateTo || ""
    }`
  );
};

export const findAllHistory = async (
  currentPage,
  perPage,
  search,
  searchDateFrom,
  searchDateTo,
  user_id
) => {
  return await GET(
    `/admin/wallet/history?page=${currentPage || 1}&per_page=${
      perPage || 10
    }&name=${search || ""}&from=${searchDateFrom || ""}&to=${
      searchDateTo || ""
    }&user_id=${user_id || ""}`
  );
};

export const Create = async (data) => {
  return await POST(`/admin/wallet`, data);
};


export const AddRemovePoints = async (id,data) => {
  return await POST(`/admin/wallet/add-remove-points/${id}`, data);
};

export const Status = async (id, data) => {
  return await POST(`/admin/wallet/${id}`, data);
};
